<div class="row">
  <div class="col-md-12">
    <div id="search-component">
      <slotcom-search-input
        class="searchbar-right-align"
        [label]="'home.friends.searchFriends' | translate"
        (valueChange)="onSearch($event)"
        (blurInput)="isDropdownOpen = false">
        <span
          icon
          class="icons-sprite tiny find"></span>
      </slotcom-search-input>

      @if (isDropdownOpen && friends().length > 0) {
        <div
          class="autocomplete-panel"
          (mousedown)="$event.preventDefault()">
          @for (friend of friends(); track friend) {
            <div
              class="autocomplete-option"
              (click)="selectFriend(friend.nickName)">
              <slotcom-friends-item [friend]="friend"></slotcom-friends-item>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
